import { SubAPI } from "./SubAPI";
export class QuotePriceSectionNotes extends SubAPI {
    list(props) { return this.fetcher.get("/api/quote-price-section-notes", props); }
    upsert(props) { return this.fetcher.post("/api/quote-price-section-note", props); }
}
